import React, { useEffect, useState } from "react";
import NewsEventsCard from "./NewsEventsCard";
import BreadCrumbBanner from "../component/BreadCrumbBanner";
import newsEventAPI from "../api/newsEventApi";

const NewsAndEvents = () => {
  const [newsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState("All");

const categories = ["All", ...new Set(newsData.map((item) => item.category))];

  const filteredData =
    activeCategory === "All"
      ? newsData
      : newsData.filter((item) => item.category === activeCategory);

  useEffect(() => {
    const fetchVisitors = async () => {
      try {
        const response = await newsEventAPI.news_events_api();
        if (response.code === 200) {
          setNewsData(response.data["news-events"]);
        }
      } catch (error) {
        console.error("Error fetching news and events:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchVisitors();
  }, []);



  return (
    <>
      {/* BreadCrumbBanner */}
      <BreadCrumbBanner
        title="News & Events"
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      <section className="mrv-news-hub">
        <div className="container">
          <div className="mrv-hub-header">
            <h2 className="mrv-title">News & Events Hub</h2>
          </div>
          {/* FILTER TABS */}
          <div className="mrv-filter-wrap">
            {categories.map((cat, index) => (
              <button
                key={index}
                className={`filter-btn ${
                  activeCategory === cat ? "active" : ""
                }`}
                onClick={() => setActiveCategory(cat)}
              >
               {cat === "All" ? "All Updates" : cat}
              </button>
            ))}
          </div>

          <div className="row g-4" id="event-container">
              {loading ? (
              <div className="text-center py-5">
                <p>Loading...</p>
              </div>
            ) : (
            filteredData.map((news) => (
              <NewsEventsCard key={news.id} news={news} />
            )))}
          </div>
        </div>
      </section>
    </>
  );
};

export default NewsAndEvents;
